import React from 'react';
import { Card, Empty } from '../bi/BiUi';
import { inputCls } from './AttendanceSection';

/** Section B: subject tabs -> Topic Taught, Homework, Due Date, Reference link. */
export default function SubjectMatrix({ subjectDefs, subj, activeSubject, setActiveSubject, setField }) {
  const cur = subj[activeSubject] || {};
  return (
    <Card title="B. Subject Homework & Topic Taught" subtitle="Subjects come from the class diary configuration">
      {!subjectDefs.length ? <Empty>No subjects configured for this class (Diary Manager).</Empty> : (
        <>
          <div className="mb-3 flex flex-wrap gap-2">
            {subjectDefs.map((d) => {
              const filled = subj[d.name] && (subj[d.name].topic || subj[d.name].homework);
              return (
                <button key={d.name} type="button" onClick={() => setActiveSubject(d.name)}
                  className={`rounded-full border px-3 py-1 text-xs font-medium ${activeSubject === d.name ? 'border-cyan-400 bg-cyan-500/20 text-cyan-200' : 'border-slate-700 text-slate-300 hover:bg-slate-800'}`}>
                  {filled ? '✔ ' : ''}{d.displayName}
                </button>
              );
            })}
          </div>
          <div className="grid gap-3 md:grid-cols-2">
            <label className="text-xs text-slate-400">Topic Taught Today
              <input className={inputCls} value={cur.topic || ''} onChange={(e) => setField(activeSubject, 'topic', e.target.value)} placeholder="e.g. Fractions - addition" /></label>
            <label className="text-xs text-slate-400">Due Date
              <input type="date" className={inputCls} value={cur.dueDate || ''} onChange={(e) => setField(activeSubject, 'dueDate', e.target.value)} /></label>
            <label className="text-xs text-slate-400 md:col-span-2">Homework Assigned
              <textarea rows={3} className={inputCls} value={cur.homework || ''} onChange={(e) => setField(activeSubject, 'homework', e.target.value)} placeholder="Exercise 4.2, Q1-5" /></label>
            <label className="text-xs text-slate-400 md:col-span-2">Attachment / Reference link
              <input className={inputCls} value={cur.link || ''} onChange={(e) => setField(activeSubject, 'link', e.target.value)} placeholder="https://..." /></label>
          </div>
        </>
      )}
    </Card>
  );
}
